import React, { useCallback, useEffect, useState } from 'react';
import { Layout, Row, Col, Typography, Checkbox, Tag, Button, Input, Table, Flex } from 'antd';
import { SearchOutlined, ExportOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
const { Title } = Typography;


const Transactions = () => {
    const [dataLoading, setDataLoading] = useState(true);
    const [transactions, setTransactions] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [planTransactions, setPlanTransactions] = useState([]);
    const [planFilteredData, setPlanFilteredData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [transactionsType, setTransactionsType] = useState('plan');
    const currentMonth = dayjs().format('YYYY-MM');
    const previousMonth = dayjs().subtract(1, 'month').format('YYYY-MM');


    const fetchCustomerOverviewData = useCallback(async () => {
        const url = `${window.API_BASE_URL}/superadmin/transactions`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            console.log(data);
            if (response.ok) {
                setTransactions(data?.transactions);
                setFilteredData(data?.transactions);
            }
        } catch (error) {
            console.error('Error during fetching store data:', error);
        } finally {
            setDataLoading(false);
        }
    }, []);

    const fetchPlanTransactionsData = useCallback(async () => {
        const url = `${window.API_BASE_URL}/superadmin/plan-transactions`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            console.log(data);
            if (response.ok) {
                setPlanTransactions(data?.transactions);
                setPlanFilteredData(data?.transactions);
            }
        } catch (error) {
            console.error('Error during fetching store data:', error);
        } finally {
            setDataLoading(false);
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            await fetchCustomerOverviewData();
            await fetchPlanTransactionsData();
            setDataLoading(false);
        };
        fetchData();
    }, [fetchCustomerOverviewData, fetchPlanTransactionsData]);

    const columns = [
        {
            title: <Checkbox />,
            dataIndex: 'checkbox',
            render: () => <Checkbox />,
        },
        {
            title: 'Transaction ID',
            dataIndex: 'payment_id',
        },
        {
            title: 'Amount ($)',
            dataIndex: 'total_price',
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
        },
        {
            title: 'Payment Method',
            dataIndex: 'transaction_id',
            render: (_, record) => (JSON.parse(record?.payment_response)?.data?.paymentInstrument?.type),
        },
        {
            title: 'Merchent',
            dataIndex: 'updated_at',
            render: (_, record) => ('PhonePay'),
        },
        {
            title: 'Status',
            dataIndex: 'payment_status',
            render: (status) => (
                <Tag color={status === 'completed' ? 'green' : 'orange'}>
                    {status}
                </Tag>
            ),
        }
    ];

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchText(value);
        const filtered = transactions.filter((transaction) => {
            return (
                transaction.transactionID.toLowerCase().includes(value) ||
                transaction.merchant.toLowerCase().includes(value) ||
                transaction.paymentMethod.toLowerCase().includes(value) ||
                transaction.status.toLowerCase().includes(value)
            );
        });
        setFilteredData(filtered);
    };

    const handleExport = () => {
        // Implement export functionality here
        console.log('Export transaction data to CSV or Excel');
    };

    return (
        <Layout className='contentLayout'>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
                <Title level={3} style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                    <b>Recent Transactions</b>
                </Title>
                <Flex justify='flex-end' align='center' gap={16}>
                    <Button onClick={() => setTransactionsType('plan')} type={transactionsType === 'plan' ? 'primary' : 'default'} shape='round'>Plan Transactions</Button>
                    <Button onClick={() => setTransactionsType('credit')} type={transactionsType === 'credit' ? 'primary' : 'default'} shape='round'>Credit Transactions</Button>
                </Flex>
            </div>
            <Row gutter={16}>
                <Col span={24}>
                    <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                        <Input
                            placeholder="Search transactions..."
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={handleSearch}
                            style={{ width: 200 }}
                        />
                        <Button
                            icon={<ExportOutlined />}
                            onClick={handleExport}
                        >
                            Export
                        </Button>
                    </div>
                    {transactionsType === 'plan' ? (
                        <Table
                            dataSource={searchText ? planFilteredData : planTransactions}
                            columns={columns}
                            pagination={{ pageSize: 10 }}
                            loading={dataLoading}
                        />
                    ) : transactionsType === 'credit' && (
                        <Table
                            dataSource={searchText ? filteredData : transactions}
                            columns={columns}
                            pagination={{ pageSize: 10 }}
                            loading={dataLoading}
                        />
                    )}
                </Col>
            </Row>
        </Layout>
    );
};

export default Transactions;